/* Il Botteghino - mega menu della barra del computer (sezione header con blocchi, snippet bt-mega). Nessuna libreria.
   Mouse: il pannello si apre dopo una breve pausa sulla voce (niente lampi passando sopra) e si chiude poco dopo l'uscita dalla barra.
   Freccia accanto alla voce: apre e chiude con clic, Invio o spazio. Touch: il primo tocco sulla voce apre il pannello, il secondo segue il link.
   Esc chiude e riporta il fuoco sulla freccia. Senza questo file i pannelli si aprono comunque con :hover e :focus-within (CSS). */
(function () {
  "use strict";
  var MQ = window.matchMedia ? window.matchMedia("(min-width: 1200px)") : { matches: true };
  var nav = null, cur = null, tOpen = 0, tClose = 0, warmed = false, lastPointer = "mouse";

  function toggleOf(it) { return it ? it.querySelector("[data-mega-toggle]") : null; }
  function hasPanel(it) { return !!(it && it.querySelector("[data-mega-panel]")); }
  function clearT() { clearTimeout(tOpen); clearTimeout(tClose); }

  /* le immagini dei pannelli sono lazy: al primo passaggio sulla barra si caricano tutte, così il pannello si apre già pieno */
  function warm() {
    if (warmed || !nav) return;
    warmed = true;
    Array.prototype.forEach.call(nav.querySelectorAll("[data-mega-panel] img[loading=lazy]"), function (img) { img.loading = "eager"; });
  }

  function set(it) {
    if (!hasPanel(it)) it = null;
    if (it === cur || !nav) return;
    if (cur && it) {
      /* da un pannello all'altro: cambio secco, senza dissolvenza */
      nav.setAttribute("data-instant", "");
      requestAnimationFrame(function () { requestAnimationFrame(function () { if (nav) nav.removeAttribute("data-instant"); }); });
    }
    if (cur) {
      cur.removeAttribute("data-mega-open");
      var b = toggleOf(cur);
      if (b) b.setAttribute("aria-expanded", "false");
    }
    cur = it;
    if (cur) {
      warm();
      cur.setAttribute("data-mega-open", "");
      var c = toggleOf(cur);
      if (c) c.setAttribute("aria-expanded", "true");
    }
  }

  function init(el) {
    if (!el || el.btMega) return;
    el.btMega = true;
    nav = el;
    cur = null;
    warmed = false;
    clearT();
    nav.classList.add("is-js");

    nav.addEventListener("pointerdown", function (e) { lastPointer = e.pointerType || "mouse"; });
    nav.addEventListener("pointerenter", function (e) { if (e.pointerType === "mouse") { clearTimeout(tClose); warm(); } });
    nav.addEventListener("pointerleave", function (e) {
      if (e.pointerType !== "mouse") return;
      clearTimeout(tOpen);
      if (cur) tClose = setTimeout(function () { set(null); }, 200);
    });
    nav.addEventListener("focusin", function (e) {
      warm();
      if (cur && !cur.contains(e.target)) set(null);
    });
    nav.addEventListener("focusout", function (e) {
      var to = e.relatedTarget;
      if (!cur || (to && nav.contains(to)) || nav.matches(":hover")) return;
      set(null);
    });

    Array.prototype.forEach.call(nav.querySelectorAll("[data-mega-item]"), function (it) {
      it.addEventListener("pointerenter", function (e) {
        if (e.pointerType !== "mouse" || !MQ.matches) return;
        clearT();
        tOpen = setTimeout(function () { set(it); }, cur ? 120 : 80);
      });
      it.addEventListener("pointerleave", function (e) { if (e.pointerType === "mouse") clearTimeout(tOpen); });

      var b = toggleOf(it);
      if (b) b.addEventListener("click", function () { clearT(); set(cur === it ? null : it); });

      var top = it.querySelector("[data-mega-top]");
      if (top) top.addEventListener("click", function (e) {
        /* touch o penna: il primo tocco apre il pannello invece di cambiare pagina */
        if (e.detail > 0 && lastPointer !== "mouse" && MQ.matches && cur !== it) {
          e.preventDefault();
          clearT();
          set(it);
        }
      });
    });
  }

  function boot() { init(document.querySelector("[data-mega]")); }

  document.addEventListener("keydown", function (e) {
    if (e.key !== "Escape" || !cur || !nav) return;
    var b = toggleOf(cur), inside = nav.contains(document.activeElement);
    set(null);
    if (inside && b) b.focus();
  });
  document.addEventListener("click", function (e) { if (cur && nav && !nav.contains(e.target)) set(null); });
  window.addEventListener("pageshow", function () { clearT(); set(null); });
  if (MQ.addEventListener) MQ.addEventListener("change", function () { if (!MQ.matches) set(null); });
  else if (MQ.addListener) MQ.addListener(function () { if (!MQ.matches) set(null); });

  /* editor del tema: selezionando una voce il suo pannello resta aperto */
  document.addEventListener("shopify:block:select", function (e) {
    var it = e.target && e.target.closest ? e.target.closest("[data-mega-item]") : null;
    if (it && nav && nav.contains(it)) { clearT(); set(it); }
  });
  document.addEventListener("shopify:block:deselect", function (e) { if (cur && cur.contains(e.target)) set(null); });
  document.addEventListener("shopify:section:load", boot);

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", boot);
  else boot();
})();
